"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocaleData = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

/**
 * Returns data for the current user's locale according to MomentJS. It's important that this not
 * be called until I18n is ready. For UIComponents, this means waiting until render.
 *
 * @param {string} localeOverride For testing purposes only!
 * @return {Object}
 */
var getLocaleData = (0, _memoize.default)(function (localeOverride) {
  var locale = localeOverride || (_I18n.default.moment.locale || _I18n.default.moment.lang)();

  return (_I18n.default.moment.localeData || _I18n.default.moment.langData)(locale);
});
exports.getLocaleData = getLocaleData;